import { resolveDynatraceRumUrl } from './dynatraceRumConfig'

export function loadDynatraceRum(): void {
  const url = resolveDynatraceRumUrl()
  if (typeof document === 'undefined' || !url) return
  const script = document.createElement('script')
  script.src = url
  script.async = true
  document.head.appendChild(script)
}
